import { Environment } from '@repo/constants'
import { FeatureFlags } from './features'

const LOCAL: FeatureFlags = {
  partnerships: true,
  'ticket-scan': true,
  'fleet-csv-import': true,
  'test-drivers': true,
  'e2e-fixtures': true,
  'client-recorder': true,
  'supervisor-qr-signature': true,
  'supervisor-truck-map': true,
}

const DEV: FeatureFlags = {
  partnerships: false,
  'ticket-scan': true,
  'fleet-csv-import': true,
  'test-drivers': true,
  // The e2e gate on the dev -> main PR runs against dev (E2E-01, E2E-08).
  'e2e-fixtures': true,
  'client-recorder': true,
  // The supervisor's QR signature (PET-3000), tried on dev and staging before prod.
  'supervisor-qr-signature': true,
  // Truck positions on the supervisor app's map (SUP-61), tried before prod.
  'supervisor-truck-map': true,
}

const STAGING: FeatureFlags = {
  partnerships: false,
  'ticket-scan': true,
  'fleet-csv-import': true,
  'test-drivers': true,
  'e2e-fixtures': true,
  // Recordings go to the dev test lab, labelled staging (REC-04).
  'client-recorder': true,
  'supervisor-qr-signature': true,
  'supervisor-truck-map': true,
}

const PROD: FeatureFlags = {
  partnerships: false,
  'ticket-scan': true,
  'fleet-csv-import': false,
  'test-drivers': false,
  'e2e-fixtures': false,
  'client-recorder': true,
  'supervisor-qr-signature': false,
  'supervisor-truck-map': false,
}

export const FEATURE_FLAGS_ENV: Record<Environment, FeatureFlags> = {
  LOCAL,
  DEV,
  PROD,
  STAGING,
}
